(function ($) {
    var inbox = {};
    var APPLICATION_ICON_SELECTOR = '[data-field="application-icon"] span';
    var INVITATION_ICON_SELECTOR = '[data-field="invitation-icon"] span';

    inbox.invite_render = function () {
        var $item = $(this);
        $item.find(INVITATION_ICON_SELECTOR).renderListBoxIcon(window.STATIC_URL + 'portal/img/svg-icons/clans/received.svg', gettext("invitation"));

        $item.addListBoxDropDown({
            'accept': {
                'title': gettext('Accept'),
                'handler': function ($item) {
                    wg_errors.clearErrors();
                    wg_modal.showThrobber();
                    clans.callEndpoint({
                        endpoint: 'accept_invite',
                        data: {
                            invite_id: $item.data('invite-id')
                        },
                        success: null /* server should send redirect on success */,
                        failure: null /* use default action which shows a message */
                    });
                }
            },
            'decline': {
                'title': gettext('Decline'),
                'handler': function ($item) {
                    wg_errors.clearErrors();
                    wg_modal.showThrobber();
                    clans.callEndpoint({
                        endpoint: 'decline_invite',
                        data: {
                            invite_id: $item.data('invite-id')
                        },
                        success: function () {
                            $item.removeItem();
                            wg_modal.hideThrobber();
                        },
                        failure: null  /* use default action which shows a message */
                    });

                }
            }
        });
    };

    inbox.application_render = function () {
        var $item = $(this);
        $item.find(APPLICATION_ICON_SELECTOR).renderListBoxIcon(window.STATIC_URL + 'portal/img/svg-icons/clans/sent.svg', gettext("application"));
    };

    window.inbox = inbox;

})(jQuery);
